<script lang="ts">
    import {Flex} from 'shared/layouts';
    import {getLocalization} from 'src/core';
    import {KpPopover, type TogglePopoverFn} from 'shared/ui-widgets/popover';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {get} from 'svelte/store';
    import {exists, isFunction} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {wrapInHeadingCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();
    const headingLevels = [1, 2, 3, 4, 5];

    let togglePopover: TogglePopoverFn;

    function setHeading(level: number) {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(wrapInHeadingCommand.key, level)
        );

        if (isFunction(togglePopover)) {
            togglePopover(false);
        }
    }
</script>

<KpPopover bind:togglePopover>
    <svelte:fragment slot="whole-button" let:buttonId let:panelId let:floatingRef>
        <ToolbarButton icon="heading"
                       tooltipLabel={localize(/* @kp-localization richTextArea.tools.heading */ 'richTextArea.tools.heading')}
                       id={buttonId}
                       popovertarget={panelId}
                       use={[floatingRef]}/>
    </svelte:fragment>

    <svelte:fragment slot="popover-content">
        <Flex direction="column">
            {#each headingLevels as level}
                <KpButton buttonSize="xs" buttonStyle="no-background" on:click={() => setHeading(level)}>
                    {localize(/* @kp-localization richTextArea.tools.headingLabel */ 'richTextArea.tools.headingLabel')} {level}
                </KpButton>
            {/each}
        </Flex>
    </svelte:fragment>
</KpPopover>